import React from 'react';

import { Chip } from '@mui/material';

import FontAwesomeIcon from 'features/common/FontAwesomeIcon';

const color = 'var(--highlighted-text)';
const backgroundColor = '#2d2a22';
const icon = <FontAwesomeIcon name="flag-pennant" gold size="11px" />;
const label = 'BETA';

export function BetaChip() {
  return (
    <Chip
      icon={icon}
      label={label}
      sx={{
        marginLeft: '8px',
        borderRadius: '4px',
        color,
        backgroundColor,
        '& .MuiChip-label': {
          fontSize: '12px',
        },
      }}
      size="small"
    />
  );
}
